import { toggleChatListPending } from '../chatList/actions';
import {
  fetchChatsBulkOperationsRestoreAllFromArchiveDesktop,
  TChatsBulkOperationsRestoreAllFromArchiveDesktopResponse,
} from '../../repositories/chats/v1/chats/bulk-operations/restore-all-from-archive-desktop';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';

/**
 * Восстановить из архива все чаты
 */
export const restoreAllChatsFromArchive = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const { httpApi, logger } = context;

  dispatch(toggleChatListPending(true));

  try {
    const { statusCode, response }: TChatsBulkOperationsRestoreAllFromArchiveDesktopResponse =
      await fetchChatsBulkOperationsRestoreAllFromArchiveDesktop({
        httpApi,
        config: { requestConfig: { withCredentials: true } },
      });

    if (statusCode !== 200) {
      logger.warning('Код ответа не 200', {
        message: 'Не удалось восстановить из архива все чаты',
        domain: 'src/shared/actions/chatList/restoreAllChatsFromArchive.ts',
        statusCode,
        messsage: response.message || 'Неизвестная ошибка',
        errors: JSON.stringify(response?.errors),
      });

      dispatch(showAlert({ message: 'Не удалось восстановить из архива все чаты' }));
    }
  } catch (ex) {
    logger.error(ex, {
      message: 'Не удалось восстановить из архива все чаты',
      domain: 'src/shared/actions/chatList/restoreAllChatsFromArchive.ts',
    });

    dispatch(showAlert({ message: 'Не удалось восстановить из архива все чаты' }));
  } finally {
    dispatch(toggleChatListPending(false));
  }
};
